import { EPaymentCreationType } from "./EPaymentCreationType";

export const TopUpPaymentTypes: ReadonlyArray<string> = [
  EPaymentCreationType.SAME_DAY_RESERVE_TOP_UP,
  EPaymentCreationType.SAME_DAY_FASTER_RESERVE_TOP_UP,
];
